import React, { ReactNode } from 'react';

import './styles.scss';

interface ISection {
  title?: string;
  heading?: string;
  children?: ReactNode
}

const Section: React.FC<ISection> = ({ heading, title, children }) => {
  return (
    <div className='section p-side relative'>
      {(title || heading) && <p className={heading ? 'heading' : 'title'}>{title || heading}</p>}
      {children}
    </div>
  );
};

export default Section;
